import { IFilterType } from '@modules/filter/domain/models/filterCategory.model';
import { ICategoryMenuList, IMenuList } from '@modules/header/domain/models/menu.model';
import { CollectionResponse, GroupCategoryResponse, MeatCategoryResponse, RecipeMethodResponse, RecipeTypeResponse } from '@modules/libs/graphql/generated/graphql';
export interface ICategoryMenuResponse {
  getWhatShouldIEatRecipeTypes: RecipeTypeResponse[];
  getWhatShouldIEatRecipeMethods: RecipeMethodResponse[];
  getWhatShouldIEatCollections: CollectionResponse[];
  getWhatShouldIEatGroupCategories: GroupCategoryResponse[];
  getWhatShouldIEatMeatCategories: MeatCategoryResponse[];
}
export class CategoryMenuEntityMapper {
  public static toDomain(categoryMenuResponse: ICategoryMenuResponse): ICategoryMenuList {
    return {
      foodType: this.menuListWithSearchPageMapper(categoryMenuResponse.getWhatShouldIEatRecipeTypes, 'foodType'),
      cooking: this.menuListWithSearchPageMapper(categoryMenuResponse.getWhatShouldIEatRecipeMethods, 'cooking'),
      collection: this.menuListWithDetailPageMapper(categoryMenuResponse.getWhatShouldIEatCollections, '/collection'),
      group: this.menuListWithDetailPageMapper(categoryMenuResponse.getWhatShouldIEatGroupCategories, '/recipe-group'),
      meatCategory: this.menuListWithSearchPageMapper(categoryMenuResponse.getWhatShouldIEatMeatCategories, 'meats')
    };
  }
  private static menuListWithDetailPageMapper(data: CollectionResponse[] | GroupCategoryResponse[], pagePath: string): IMenuList[] {
    return data.map(({
      id,
      title,
      slugUrl
    }: CollectionResponse | GroupCategoryResponse) => {
      return {
        id,
        title,
        linkOut: `${pagePath}/${slugUrl}`
      };
    });
  }
  private static menuListWithSearchPageMapper(data: RecipeTypeResponse[] | RecipeMethodResponse[] | MeatCategoryResponse[], filterType: keyof IFilterType): IMenuList[] {
    return data.map(({
      id,
      title
    }) => {
      return {
        id,
        title,
        linkOut: `/search?c=Recipe&f=r_${filterType}_${id}`
      };
    });
  }
}